import { mainApi } from "../../../../api";

export const bannerQuery = (isDisabled?:boolean) => ({
    queryKey: ["banner"],
    queryFn: async () => mainApi.get("get_baner"),
    isEnabled: !isDisabled
});
